<lot-unit-table [heading]="'Products' | tenantWords" [keyHeader]="'Product' | tenantWords" [rows]="this.rows"></lot-unit-table>
